import React from 'react';
import { getStatusConfig } from '../../utils/helpers';

const StatusBadge = ({ status }) => {
  const config = getStatusConfig(status);

  return (
    <span className={`badge ${config.badgeClass}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;


